import type { DividerProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { ColorField, NumberField, SelectField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const STYLES = ["solid", "dashed", "dotted"] as const;

export function DividerInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as DividerProps;

  return (
    <>
      <ColorField
        label="Color"
        value={p.color ?? "#000000"}
        onChange={(v) => update(widget.id, { color: v })}
      />
      <SelectField
        label="Style"
        value={p.style ?? "solid"}
        options={STYLES}
        onChange={(v) => update(widget.id, { style: v })}
      />
      <NumberField
        label="Thickness (px)"
        value={p.thickness ?? 1}
        min={1}
        max={10}
        onChange={(v) => update(widget.id, { thickness: v })}
      />
      <NumberField
        label="Spacing (px)"
        value={p.spacing ?? 16}
        min={0}
        max={200}
        onChange={(v) => update(widget.id, { spacing: v })}
      />
    </>
  );
}
